import React, { useState } from "react";
import DatePicker from "react-datepicker";

const d = new Date();
d.setMinutes(0);
d.setHours(0);

export type Props = {
  name?: string | null;
  label?: string | null;
};

export const Datetime: React.FC<Props> = ({ name, label }) => {
  const [date, setDate] = useState<Date | undefined>(undefined);
  
  const [open, setOpen] = useState(false);

  const handleChange = (date: Date) => {
    setDate(date);
    setOpen(false);
  }

  return (
    <div className="datetime-picker">
      {open ? (
        <div className="dt-wrapper">
          <label className="_field__label">{label}</label>
          <DatePicker
            selected={date}
            inline
            dateFormat="yyyy-MM-dd"
            onChange={handleChange}
          />
        </div>
      ) : (
        <div className="_field">
          <input
            name={name || "properties[Delivery Date]"}
            onClick={() => setOpen(true)}
            type="text"
            id="recipient_email"
            className="_field__input"
            aria-required="true"
            value={date?.toLocaleDateString("en-AU", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}
            placeholder={label ? label : "Select date and time"}
          />
          <label htmlFor="recipient_email" className="_field__label">{label}</label>
        </div>
      )}
    </div>
  );
};
